import React, { useContext } from "react";
import { exact, PropTypes } from "prop-types";
import { Card, Heading, Subtitle } from "uikit/components";
import styles from "./SportsmanRatingInfo.module.styl";
import { MediaContext } from "app/media/MediaContext";

export default function SportsmanRatingInfo({ ratingInfo }) {
    const { isDesktop } = useContext(MediaContext);

    return (
        <Card borderRadius={"giant"} className={styles.container}>
            <div>
                <Heading size={isDesktop ? "h1" : "h2"} className={styles.heading}>
                    {ratingInfo.placeInCountry}
                </Heading>
                <Subtitle size={isDesktop ? "subtitle-2" : "subtitle-3"}>
                    Место в рейтинге РФ
                </Subtitle>
            </div>

            <div>
                <Heading size={isDesktop ? "h1" : "h2"} className={styles.heading}>
                    {ratingInfo.placeInRegion}
                </Heading>
                <Subtitle size={isDesktop ? "subtitle-2" : "subtitle-3"}>
                    Место в рейтинге внутри субъекта РФ
                </Subtitle>
            </div>

            <div>
                <Heading size={isDesktop ? "h1" : "h2"} className={styles.heading}>
                    {ratingInfo.placeInSchool}
                </Heading>
                <Subtitle size={isDesktop ? "subtitle-2" : "subtitle-3"}>
                    Место в рейтинге организации
                </Subtitle>
            </div>
        </Card>
    );
}

SportsmanRatingInfo.propTypes = {
    ratingInfo: exact({
        placeInCountry: PropTypes.number.isRequired,
        placeInRegion: PropTypes.number.isRequired,
        placeInSchool: PropTypes.number.isRequired,
    }).isRequired,
};
